import StatusPill from './StatusPill.jsx'
import { REQUIREMENT_LABELS } from './impactInBeeldConfig.js'

/**
 * Card for one Impact in beeld channel: title, description, requirement chips,
 * status pill and the enable action. See docs/features/impact-in-beeld-hub.md.
 *
 * @param {object} props
 * @param {{id: string, title: string, description: string, requirements: Array<string>}} props.channel - Channel config entry
 * @param {string} props.status - 'off' | 'concept' | 'live' | 'action-needed'
 * @param {(channelId: string) => void} props.onEnable - Called when the user enables the channel
 * @param {boolean} [props.enableDisabled] - Disables the enable button while channel data loads
 * @param {(channelId: string) => void} [props.onOpenConfig] - Opens the channel's config screen (enabled channels)
 */
const ChannelCard = ({ channel, status, onEnable, enableDisabled = false, onOpenConfig }) => {

    return (
        <div className='impact-channel-card'>
            <div className='impact-channel-card-header'>
                <h3>{channel.title}</h3>
                <StatusPill status={status} />
            </div>
            <p className='impact-channel-card-description'>{channel.description}</p>
            <div className='impact-channel-card-requirements'>
                {channel.requirements.map((requirement) => (
                    <span key={requirement} className='impact-channel-requirement-chip'>
                        {REQUIREMENT_LABELS[requirement] || requirement}
                    </span>
                ))}
            </div>
            {status === 'off' ? (
                <button
                    className='impact-in-beeld-add-button'
                    onClick={() => onEnable(channel.id)}
                    disabled={enableDisabled}
                >
                    Aanzetten
                </button>
            ) : (
                <button
                    className='impact-in-beeld-add-button'
                    onClick={() => onOpenConfig && onOpenConfig(channel.id)}
                >
                    Instellen
                </button>
            )}
        </div>
    )
}

export default ChannelCard
